import * as React from 'react'

import { CompareCredit } from '../../types'
import cn from 'utils/classnames'
import { useShouldIncreaseProductVisibilityExp384 } from 'utils/experimentation/useShouldIncreaseProductVisibility'

export const PanelContents: React.FC<
  React.PropsWithChildren<{ view: CompareCredit.CardPanelProps['view'] }>
> = ({ children, view }) => {
  const isModalOrDetail = view === 'details' || view === 'modal'
  const isDetails = view === 'details'
  const isModal = view === 'modal'

  // 2025.06: EXP-384 Slim Category Design
  const shouldIncreaseProductVisibility =
    useShouldIncreaseProductVisibilityExp384()

  return (
    <div
      className={cn(
        `c-product-panel__card / md:flex md:w-full md:flex-wrap / px-6 xs:px-8 / md:pb-3 lg:pb-0 lg:pb-4`,
        {
          'md:flex-col / mb-20 / md:px-10 md:pb-2 / lg:px-12 lg:pb-4 / xl:px-16':
            isModalOrDetail,
          'md:px-6 md:pt-6 / lg:px-8 lg:pt-7 / xl:px-10':
            !isModalOrDetail && !shouldIncreaseProductVisibility,
          'md:px-4 md:pt-4 / lg:px-6 lg:pt-6':
            !isModalOrDetail && shouldIncreaseProductVisibility,
          'pb-6 md:pt-8 lg:pt-10 xl:pt-12': isDetails,
          'pt-0 pb-2 leading-normal': isModal,
          'pt-7 xs:pt-10': !isModal,
        },
      )}
    >
      {children}
    </div>
  )
}
